import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles, Slide } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import _ from "lodash";
import { images } from "../../utils/images";
import { getAcceptedIDtypes } from "../../actions/index";

// Icons
import {
  RadioButtonUnchecked,
  CheckCircle,
  ArrowBack,
  PhotoCamera,
  CloudUpload,
} from "@material-ui/icons";

// Components
import Loader from "../Loader";
import Selector2 from "../Selector2";
import TwoSidedID from "./TwoSidedID";
import OneSidedID from "./OneSidedID";

function IdUpload(props) {
  const { classes, t, idTypes } = props;
  const [selectedCountry, setSelectedCountry] = useState("");
  const [issuingCountry, setIssuingCountry] = useState(null);
  const [idTypeChosen, setIdTypeChosen] = useState(null);
  const [method, setMethod] = useState(null);
  const [idPhotos, setIdPhotos] = useState(null);

  useEffect(() => {
    props.getAcceptedIDtypes();
  }, []);

  useEffect(
    function () {
      if (selectedCountry !== "") {
        let country = idTypes.acceptedIdTypes.find(
          (c) => c.countryName === selectedCountry
        );

        setIssuingCountry(country);
        setIdTypeChosen(null);
        setMethod(null);
        setIdPhotos(null);
      }
    },
    [selectedCountry]
  );

  useEffect(() => {
    if (idPhotos) {
      props.addIdPhotos(idPhotos);
      props.addIssuingCountry(issuingCountry);
      props.addIdType(idTypeChosen);
      props.triggerJumioRequest(true);
      // props.moveForward(true);
    }
  }, [idPhotos]);

  if (idTypes === null) {
    return <Loader />;
  }

  if (idTypes == null) {
    return (
      <div style={{ marginTop: 24 }}>
        <Loader />
      </div>
    );
  }

  let countriesJumio = _.sortBy(
    idTypes.acceptedIdTypes.map((t) => t.countryName)
  );

  return (
    <Slide in direction="left">
      <div className={classes.container}>
        <div className="stepBody">
          <div className="left">
            <h2 dangerouslySetInnerHTML={{ __html: t("uploadId") }} />
            <p className="label">{t("chooseIssuingCountry")}</p>
            <Selector2
              options={countriesJumio}
              // width="80%"
              selectorHandle={setSelectedCountry}
              selectedOption={selectedCountry}
            />
            {issuingCountry && idTypeChosen === null ? (
              <div className="idOptions">
                <p className="label">{t("selectIDtype")}</p>
                <p className="sublabel">{t("typeInfo")}</p>
                <div className="optionsContainer">
                  {issuingCountry.idTypes.map((type, idx) => {
                    return (
                      <div
                        key={idx}
                        className="idOption"
                        onClick={() => setIdTypeChosen(type)}
                      >
                        <RadioButtonUnchecked />
                        <p>
                          {t(type.idType.split("_").join("").toLowerCase())}
                        </p>
                        <img src={images.icons[type.idType.toLowerCase()]} />
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : issuingCountry && idTypeChosen ? (
              <div className="idOptions">
                <p className="label">{t("selectIDtype")}</p>
                <p className="sublabel">{t("typeInfo")}</p>
                <ArrowBack
                  classes={{ root: classes.arrowBack }}
                  onClick={() => {
                    setMethod(null);
                    setIdTypeChosen(null);
                  }}
                />
                <div className="idOption chosenType">
                  <CheckCircle classes={{ root: classes.chosenIcon }} />
                  <p>
                    {t(idTypeChosen.idType.split("_").join("").toLowerCase())}
                  </p>
                  <img
                    src={
                      images.icons[idTypeChosen.idType.toLowerCase() + "_white"]
                    }
                  />
                </div>
                <div className="photoMethods">
                  <div
                    className={`btnOption ${
                      method === "camera" ? "activemethod" : ""
                    }`}
                    onClick={() => setMethod("camera")}
                  >
                    <p>{t("takePhoto")}</p>
                    {method === "camera" ? (
                      <img src={images.icons.cameraWhite} />
                    ) : (
                      <img src={images.icons.camera} />
                    )}
                  </div>
                  <div
                    className={`btnOption ${
                      method === "upload" ? "activemethod" : ""
                    }`}
                    onClick={() => setMethod("upload")}
                  >
                    <p>{t("uploadFile")}</p>
                    {method === "upload" ? (
                      <img src={images.icons.uploadWhite} />
                    ) : (
                      <img src={images.icons.upload} />
                    )}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="right">
            {idTypeChosen ? (
              idTypeChosen.acquisitionConfig.backSide ? (
                <TwoSidedID
                  method={method}
                  setPhotos={setIdPhotos}
                  restart={false}
                />
              ) : (
                <OneSidedID
                  method={method}
                  setPhoto={setIdPhotos}
                  restart={false}
                />
              )
            ) : (
              <img
                style={{ width: "100%", height: "auto", objectFit: "contain" }}
                src={images.illustrations.documentIllustrationSolo}
              />
            )}
          </div>
        </div>
      </div>
    </Slide>
  );
}

function mapStateToProps(state) {
  return {
    idTypes: state.idTypes,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getAcceptedIDtypes,
    },
    dispatch
  );
}

const styles = (theme) => ({
  container: {
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    background: theme.colors.background.fore,
    boxShadow: theme.defaults.shadow,
    maxWidth: 880,
    width: "90%",
    padding: 40,
    color: theme.colors.text.primary,

    [theme.breakpoints.down(500)]: {
      padding: 24,
    },

    "& .stepBody": {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",

      "& .left": {
        width: "50%",
        position: "relative",
        "& h2": {
          fontSize: 28,
          fontWeight: 300,
          marginBottom: 32,
          "& b": {
            fontWeight: 600,
          },
        },
        "& .label": {
          marginBottom: 8,
        },

        "& .photoMethods": {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          margin: "24px auto 0",
          [theme.breakpoints.down(500)]: {
            flexDirection: "column",
          },
          "& .btnOption": {
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            transition: ".3s",
            textAlign: "center",
            justifyContent: "space-between",
            width: "47.5%",
            padding: 16,
            background: theme.colors.background.lightFore,
            "&.activemethod": {
              background: theme.colors.misc._blue,
              color: theme.colors.text.textOnRed,
            },
            [theme.breakpoints.down(500)]: {
              width: "100%",
              marginBottom: 8,
            },
            "& img": {
              width: 25,
              height: "auto",
            },

            "&:hover": {
              color: theme.colors.text.secondary,
            },
          },
        },

        "& button": theme.defaults.roundBtn,
        "& .confirmBtn": {
          background: theme.colors.buttons.green,
          marginTop: 32,
          float: "right",
        },

        "& .idOptions": {
          marginTop: 16,
          "& .label": {
            fontSize: 14,
          },
          "& .sublabel": {
            color: theme.colors.text.secondary,
            marginTop: 8,
            marginBottom: 8,
          },
          "& .idOption": {
            height: 95,
            width: "100%",
            border: `2px solid ${theme.colors.background.lightFore}`,
            borderRadius: 4,
            display: "flex",
            alignItems: "center",
            paddingLeft: 24,
            cursor: "pointer",
            marginBottom: 8,
            transition: ".3s",
            paddingRight: 24,
            "& img": {
              width: "auto",
              height: 55,
              marginLeft: "auto",
            },
            "&:hover": {
              background: theme.colors.background.lightFore,
            },
            "&.chosenType": {
              background: theme.colors.misc._blue,
              color: theme.colors.text.textOnRed,
              "&:hover": {
                cursor: "auto",
              },
            },

            "& svg": {
              fontSize: 32,
              marginRight: 20,
            },
            "& p": {
              textTransform: "capitalize",
            },
          },
        },
      },
      "& .right": {
        width: "45%",

        "& .cameraButtons": {
          display: "flex",
          justifyContent: "center",
          marginTop: 12,
          "& .photoBtnWrapper": {
            height: 38,
            width: 38,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            border: `2px solid ${theme.colors.buttons.blue}`,
            "& .takePhotoBtn": {
              height: 32,
              width: 32,
              borderRadius: "50%",
              background: theme.colors.buttons.blue,
              cursor: "pointer",
              transition: ".3s",
              "&:hover": {
                opacity: 0.3,
              },
            },
          },
          "& .takenBtnWrapper": {
            width: "75%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",

            "& button": {
              ...theme.defaults.roundBtn,
              color: theme.colors.misc.black,
            },
            "& .confirmBtn": {
              background: theme.colors.buttons.green,
              color: theme.colors.text.primary,
            },
          },
        },

        "& .uploadContainer": {
          width: "100%",
          height: 400,
          border: `2px dashed ${theme.colors.misc.dividers}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          "&.photoUploaded": {
            borderColor: "transparent",
          },
          "& img": {
            width: "70%",
            height: "auto",
            marginBottom: 16,
          },
          "& button": theme.defaults.roundBtn,
          "& .uploadBtn": {
            background: "transparent",
            color: theme.colors.buttons.green,
            borderColor: theme.colors.buttons.green,
            fontSize: 14,
            textTransform: "capitalize",
          },

          "& .uploadedPhotoBtns": {
            "& .confirmBtn": {
              background: theme.colors.buttons.green,
              marginLeft: 8,
            },
          },
        },
      },
      [theme.breakpoints.down(700)]: {
        flexDirection: "column",
        "& .left, & .right": {
          width: "100%",
        },
        "& .right": {
          marginTop: 24,
        },
      },
    },
  },
  arrowBack: {
    color: theme.colors.buttons.green,
    marginBottom: 8,
    transition: ".3s",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.3,
    },
  },
  choseIcon: {
    color: theme.colors.text.primary,
  },
});

export default withStyles(styles)(
  withTranslation()(connect(mapStateToProps, mapDispatchToProps)(IdUpload))
);
